import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

export type BadgeTone = 'neutral' | 'volt' | 'flare' | 'sky' | 'amber'

const tones: Record<BadgeTone, string> = {
  neutral: 'bg-white/[0.08] text-fg-muted ring-line',
  volt: 'bg-volt/15 text-volt ring-volt/25',
  flare: 'bg-flare/15 text-flare ring-flare/25',
  sky: 'bg-sky/15 text-sky ring-sky/25',
  amber: 'bg-amber/15 text-amber ring-amber/25',
}

interface BadgeProps {
  tone?: BadgeTone
  className?: string
  children: ReactNode
}

export function Badge({ tone = 'neutral', className, children }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[0.6875rem] leading-none font-semibold tracking-wide uppercase ring-1 ring-inset',
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
